<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>
              <v-icon color="#077893" @click="Fn_BackIndex" size="38"
                >mdi-chevron-left</v-icon
              >{{ $t("Cookies.detail") }}
            </h2>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center align-center pt-5>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg">
              <v-card-title primary-title class="pa-2 pl-4 black--text">
                <!-- {{ $t("Cookies.detail") }}<v-spacer></v-spacer> -->
                {{ ServiceName }}<v-spacer></v-spacer>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout
                  row
                  wrap
                  pt-8
                  justify-center
                  align-center
                  pa-3
                  class="black--text"
                >
                  <v-flex xs11 lg4 md4>
                    <b> Service Name : </b> {{ ServiceName }}
                  </v-flex>
                  <v-flex xs11 lg4 md4>
                    <b> CMP Service secret :</b>
                    <span class="blurry-text">{{ SecretId }}</span>
                    <v-icon
                      color="#077893"
                      style="cursor: pointer"
                      small
                      @click="Fn_CopyDetail(SecretId)"
                      >mdi-file-multiple-outline</v-icon
                    >
                  </v-flex>
                  <v-flex xs11 lg4 md4>
                    <b> Hostname :</b> {{ Hostname }}
                    <!-- <v-icon color="#077893" style="cursor: pointer" small @click="Fn_EditHostName()">mdi-pencil</v-icon> -->
                  </v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  pt-5
                  justify-center
                  align-center
                  pa-3
                  class="black--text"
                >
                  <v-flex xs11 lg4 md4>
                    <div v-if="$t('default') === 'th'">
                      <b> Create date : </b> {{ CreatedAt }}
                    </div>
                    <div v-else><b> Create date : </b> {{ CreatedAtEng }}</div>
                  </v-flex>
                  <v-flex xs11 lg4 md4>
                    <div v-if="$t('default') === 'th'">
                      <b> Update date : </b> {{ UpdatdeAt }}
                    </div>
                    <div v-else><b> Update date : </b> {{ UpdatdeAtEng }}</div>
                  </v-flex>
                  <v-flex xs11 lg4 md4>
                    <b> Service ID :</b> {{ ServiceId }}
                  </v-flex>
                </v-layout>
                <!-- เอกสารความยินยอม -->
                <h2 class="pb-6 pt-5 black--text">
                  {{ $t("Cookies.consent") }}
                </h2>
                <v-divider></v-divider>
                <div>
                  <v-layout row wrap pt-6 justify-start align-center pa-3>
                    <v-flex xs6 lg6 md6>
                      <div v-if="GroupId == ''">
                        {{ $t("Cookies.type") }}:
                        <b>
                          <v-chip
                            class="ma-2"
                            color="#ddf7ff"
                            text-color="#077893"
                          >
                            {{ $t("Cookies.general") }}
                          </v-chip>
                        </b>
                      </div>
                      <div v-else>
                        {{ $t("Cookies.type") }}:
                        <b>
                          <v-chip
                            class="ma-2"
                            color="#ddf7ff"
                            text-color="#077893"
                          >
                            {{ $t("Cookies.group") }}
                          </v-chip>
                        </b>
                      </div>
                    </v-flex>
                    <v-flex xs6 lg6 md6 d-flex justify-end> </v-flex>
                    <div v-if="GroupId == ''" class="black--text">
                      <v-flex xs12 lg12 md12>
                        {{ $t("Cookies.Consentnumber") }} :
                        <b> {{ ConsentId }}</b>
                        &nbsp;
                        <v-icon
                          color="#077893"
                          style="cursor: pointer"
                          small
                          @click="Fn_CopyDetail(ConsentId)"
                          >mdi-file-multiple-outline</v-icon
                        >
                      </v-flex>
                      <v-flex xs12 lg12 md12>
                        {{ $t("Cookies.Policynumber") }} :
                        <b> {{ PolicyId }}</b>
                        &nbsp;
                        <v-icon
                          color="#077893"
                          style="cursor: pointer"
                          small
                          @click="Fn_CopyDetail(PolicyId)"
                          >mdi-file-multiple-outline</v-icon
                        >
                      </v-flex>
                    </div>
                    <div v-else>
                      <v-flex xs12 lg12 md12>
                        {{ $t("Cookies.groupnumber") }} :
                        <b> {{ GroupId }}</b>
                        &nbsp;
                        <v-icon
                          color="#077893"
                          style="cursor: pointer"
                          small
                          @click="Fn_CopyDetail(GroupId)"
                          >mdi-file-multiple-outline</v-icon
                        >
                      </v-flex>
                    </div>
                  </v-layout>
                </div>
                <div>
                  <h2 class="pb-6 pt-5 black--text">Webscript</h2>
                  <v-card outlined>
                    <v-layout row wrap justify-center align-center pa-3>
                      <!-- ขั้นตอนที่ 1 -->
                      <v-flex xs12 lg3 md3>
                        <v-layout row wrap justify-center align-start pa-0 ma-0>
                          <v-flex xs2 md2 lg2>
                            <v-avatar size="25" color="#077893">
                              <span class="white--text text-h8">1</span>
                            </v-avatar>
                          </v-flex>
                          <v-flex xs10 md10 lg10>
                            <div class="black--text">
                              <b>{{ $t("Cookies.firstStep") }}</b>
                            </div>
                            <div class="black--text">
                              {{ $t("Cookies.copyScript") }}
                            </div>
                            <div class="black--text">
                              {{ $t("Cookies.addPage") }}
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <!-- icon -->
                      <v-flex xs1 lg1 md1>
                        <v-icon x-large color="grey"
                          >mdi-chevron-right</v-icon
                        ></v-flex
                      >
                      <!-- ขั้นตอนที่ 2 -->
                      <v-flex xs12 lg5 md5>
                        <v-layout row wrap justify-center align-start pa-0 ma-0>
                          <v-flex xs2 md2 lg1>
                            <v-avatar size="25" color="#077893">
                              <span class="white--text text-h8">2</span>
                            </v-avatar>
                          </v-flex>
                          <v-flex xs10 md10 lg11>
                            <div class="black--text">
                              <b>{{ $t("Cookies.secondStep") }}</b>
                            </div>
                            <div class="black--text">
                              {{ $t("Cookies.inputUserId")
                              }}{{ $t("Cookies.rowInput") }}
                            </div>
                            <div class="black--text">
                              <b
                                >`cmp-session-id
                                {{ $t("Cookies.or") }} cmp-ipaddress
                                {{ $t("Cookies.or") }} cmp-account-id`</b
                              >
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <!-- icon -->
                      <v-flex xs1 lg1 md1>
                        <v-icon x-large color="grey"
                          >mdi-chevron-right</v-icon
                        ></v-flex
                      >
                      <!-- ขั้นตอนที่ 3 -->
                      <v-flex xs12 lg2 md2>
                        <v-layout row wrap justify-center align-start pa-0 ma-0>
                          <v-flex xs2 md3 lg3>
                            <v-avatar size="25" color="#077893">
                              <span class="white--text text-h8">3</span>
                            </v-avatar>
                          </v-flex>
                          <v-flex xs10 md9 lg9>
                            <div class="black--text">
                              <b>{{ $t("Cookies.thirdStep") }}</b>
                            </div>
                            <div class="black--text">
                              {{ $t("Cookies.finish") }}
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                  <v-card class="mt-5" outlined>
                    <v-layout row wrap justify-center align-center pa-3>
                      <!-- Webscript -->
                      <v-flex xs12 lg12 md12>
                        <v-card outlined color="#dff7ff" class="pa-3 mb-3">
                          <div class="text-end">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-bind="attrs"
                                  v-on="on"
                                  color="#077893"
                                  style="cursor: pointer"
                                  @click="Fn_CopyDetail(WebScript)"
                                  >mdi-file-multiple-outline</v-icon
                                >
                              </template>
                              <span>{{ $t("consentlist.copy") }}</span>
                            </v-tooltip>
                          </div>
                          <span class="textcolor">
                            {{ line0 }} {{ line1 }} {{ linenew }}
                          </span>
                          <span
                            class="textcolor"
                            v-for="(item, index) in Script"
                            :key="index"
                          >
                            <div class="ml-6">{{ item }} <br /></div>
                          </span>
                          <div class="textcolor">
                            {{ PstringEnd }}
                          </div>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card>

                  <v-layout row wrap justify-center ma-0 pa-2>
                    <v-flex xs9 lg3 pa-4>
                      <v-card outlined class="cyan lighten-5 rounded-lg">
                        <v-card-text class="pa-2 text-center black--text">
                          <div v-if="$t('default') === 'th'">
                            <p style="font-size: 18px; color: #00695c">
                              ทั้งหมด
                            </p>
                          </div>
                          <div v-else>
                            <p style="font-size: 18px; color: #00695c">All</p>
                          </div>
                          <v-chip color="#00695C" dark
                            >{{ all }} {{ $t("consentlist.list") }}</v-chip
                          >
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <v-flex xs9 lg3 pa-4>
                      <v-card outlined class="teal lighten-5 rounded-lg">
                        <v-card-text class="pa-2 text-center black--text">
                          <p style="font-size: 18px; color: #077893">
                            {{ $t("dashboard.statusapp") }}
                          </p>
                          <v-chip color="#077893" dark
                            >{{ approve }} {{ $t("consentlist.list") }}</v-chip
                          >
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <v-flex xs9 lg3 pa-4>
                      <v-card outlined class="red lighten-5 rounded-lg">
                        <v-card-text class="pa-2 text-center black--text">
                          <p style="font-size: 18px; color: #803636">
                            {{ $t("dashboard.reject") }}
                          </p>
                          <v-chip color="#803636" dark
                            >{{ unapprove }}
                            {{ $t("consentlist.list") }}</v-chip
                          >
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <v-flex xs9 lg3 pa-4>
                      <v-card outlined class="grey lighten-1 rounded-lg">
                        <v-card-text class="pa-2 text-center black--text">
                          <p style="font-size: 18px; color: #000">
                            {{ $t("dashboard.expire") }}
                          </p>
                          <v-chip color="#000" dark
                            >{{ expire }} {{ $t("consentlist.list") }}</v-chip
                          >
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                  <div>
                    <v-data-table
                      :no-data-text="NoData"
                      :loading="tableload"
                      :loading-text="$t('overlay.load')"
                      :headers="headers"
                      :items="dashboard"
                      :page.sync="page"
                      :items-per-page="itemsPerPage"
                      hide-default-footer
                      @page-count="pageCount = $event"
                      scrollable
                    >
                      <template #no-data>
                        <v-layout row wrap justify-center align-center>
                          <v-flex lg12 xs12>
                            <br />
                            <v-icon size="50" color="error"
                              >mdi-table-large-remove</v-icon
                            >
                          </v-flex>
                          <v-flex lg12 xs12>
                            {{ NoData }}
                          </v-flex>
                        </v-layout>
                      </template>
                      <template v-slot:[`item.SendId`]="{ item }">
                        <div class="text-left">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                color="#077893"
                                style="cursor: pointer"
                                small
                                @click="Fn_CopyDetail(item.SendId)"
                                v-on="on"
                                >mdi-file-multiple-outline</v-icon
                              >
                            </template>
                            <span>{{ $t("consentlist.copy") }}</span>
                          </v-tooltip>
                          {{ item.SendId }}
                        </div>
                      </template>
                      <template v-slot:[`item.SessionId`]="{ item }">
                        <div v-if="item.SessionId !== '-'">
                          {{ item.SessionId }}
                        </div>
                        <div v-else>
                          {{ item.SessionId }}
                        </div>
                      </template>
                      <template v-slot:[`item.SendAt`]="{ item }">
                        <div v-if="$t('default') === 'th'">
                          {{ item.SendAt }}
                        </div>
                        <div v-else>
                          {{ item.SendAtEng }}
                        </div>
                      </template>
                      <template v-slot:[`item.ExpireIn`]="{ item }">
                        <div v-if="$t('default') === 'th'">
                          {{ item.ExpireIn }}
                        </div>
                        <div v-else>
                          {{ item.ExpireInEng }}
                        </div>
                      </template>
                      <template v-slot:[`item.Status`]="{ item }">
                        <v-chip
                          color="green"
                          dark
                          v-if="item.Status === 'active'"
                          >{{ $t("petition.text22v2") }}</v-chip
                        >
                        <v-chip
                          color="error"
                          dark
                          v-else-if="item.Status === 'unactive'"
                          >{{ $t("petition.text23") }}</v-chip
                        >
                        <v-chip
                          color="warning"
                          dark
                          v-else-if="item.Status === 'pending'"
                          >{{ $t("petition.text24") }}</v-chip
                        >
                        <v-chip
                          color="black"
                          dark
                          v-else-if="item.Status === 'expire'"
                          >{{ $t("dashboard.expire") }}</v-chip
                        >
                      </template>
                    </v-data-table>
                    <div class="text-center pt-2">
                      <v-pagination
                        :total-visible="7"
                        class="pt-2 pb-2"
                        circle
                        color="#077893"
                        v-model="page"
                        :length="pageCount"
                        prev-icon="mdi-menu-left"
                        next-icon="mdi-menu-right"
                      ></v-pagination>
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";
// import 'sweetalert2/src/sweetalert2.scss'
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { OverlaySearch },
  data: function () {
    return {
      loadingDownloadData: false,
      UserId: "",
      ServiceId: "",
      SecretId: "",
      Hostname: "",
      CreatedAt: "",
      CreatedAtEng: "",
      ServiceName: "",
      UpdatdeAt: "",
      UpdatdeAtEng: "",
      GroupId: "",
      ConsentId: "",
      PolicyId: "",
      SelectName: "",
      SecretIdCopy: "",
      PstringEnd: "",
      WebScript: "",
      line0: "",
      line1: "",
      line2: "",
      line3: "",
      line4: "",
      line5: "",
      line6: "",
      line7: "",
      line8: "",
      line9: "",
      line10: "",
      line11: "",
      str1: "",
      str2: "",
      str3: "",
      str4: "",
      all: "",
      linenew: "",
      approve: "",
      expire: "",
      unapprove: "",
      Script: [],
      StatusStep: 1,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      dashboard: [],
      tableload: false,
      NoData: "No data available",
    };
  },
  computed: {
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),
    ...mapGetters(["Profile"]),

    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },
    _SelectTaxId: {
      get() {
        return this.Business.TaxId || "-";
      },
    },
    headers() {
      return [
        {
          text: "Send ID",
          value: "SendId",
          align: "center",
          sortable: false,
        },
        {
          text: "Account ID",
          align: "center",
          value: "AccountId",
          sortable: false,
        },
        {
          text: "Session ID",
          align: "center",
          value: "SessionId",
          sortable: false,
        },
        {
          text: "IP Address",
          align: "center",
          value: "IpAddress",
          sortable: false,
        },
        {
          text: this.$i18n.t("consentlist.date"),
          value: "SendAt",
          sortable: false,
          align: "center",
        },
        {
          text: this.$i18n.t("dashboard.expire"),
          value: "ExpireIn",
          sortable: false,
          align: "center",
        },
        {
          text: this.$i18n.t("dashboard.status"),
          value: "Status",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
  companyth: {
    get() {
      if (this.$i18n.locale === "th") {
        return this.profile.name_on_document_th;
      } else {
        return this.profile.name_on_document_eng;
      }
    },
  },
  mounted() {
    this.GetService();
  },
  methods: {
    async Fn_CopyDetail(val) {
      this.disabledFirst = false;
      if (val === this.SecretId) {
        val = this.SecretIdCopy;
        await navigator.clipboard.writeText(val);
      } else {
        await navigator.clipboard.writeText(val);
      }
    },
    Fn_BackIndex() {
      this.$router.push("/cookies-index");
    },
    async GetService() {
      this.loadingDownloadData = true;
      var payload = {
        AccountId: this.$cookies.get("OneAccountId"),
        BusinessId: this.$cookies.get("BusinessId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
        ServiceId: this.$cookies.get("ServiceId"),
      };
      // var Headers = {
      //   AccountId: this.$cookies.get("OneAccountId"),
      // };
      // var dataEncode = await authorization.encodeDataNew(payload);
      // var auth = await authorization.encodeDataNew(Headers);
      // var headers = { Authorization: "Bearer " + auth };

      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "webscript/GetService",
          // { Data: dataEncode },
          // { headers }
          payload
        )
        .then((response) => {
          this.loadingDownloadData = false;
          if (response.data.Status === "OK") {
            this.Service = response.data.Message;
            this.Name = response.data.Message[0].Name;
            this.NameEng = response.data.Message[0].NameEng;
            this.ServiceId = response.data.Message[0].ServiceId;
            this.CreatedAt = response.data.Message[0].CreatedAt;
            this.CreatedAtEng = response.data.Message[0].CreatedAtEng;
            this.Hostname = response.data.Message[0].Hostname;
            this.SecretId = response.data.Message[0].SecretId.slice(0, 10);
            this.SecretIdCopy = response.data.Message[0].SecretId;
            this.ServiceName = response.data.Message[0].ServiceName;
            this.UpdatdeAt = response.data.Message[0].UpdatdeAt;
            this.UpdatdeAtEng = response.data.Message[0].UpdatdeAtEng;
            this.GroupId = response.data.Message[0].GroupId;
            this.ConsentId = response.data.Message[0].ConsentId;
            this.PolicyId = response.data.Message[0].PolicyId;
            this.PlusString();
            this.Fn_DashbordService();

          } else {
            Toast.fire({
              icon: "error",
              title: response.data.Message.Status,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_DashbordService() {
      this.tableload = true;
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        ConsentId: this.ConsentId,
        PolicyId: this.PolicyId,
        GroupId: this.GroupId,
      };

      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };

      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "webscript/DashbordService",
          { Data: dataEncode },
          { headers },
          payload
        )
        .then((response) => {
          this.tableload = false;
          this.loadingDownloadData = false;
          if (response.data.Status === "OK") {
            this.dashboardData = response.data.Message;
            this.dashboard = response.data.Message[0].Consent;
            this.count = response.data.Message[0].Count;
            this.all = response.data.Message[0].Count.All;
            this.approve = response.data.Message[0].Count.Approve;
            this.unapprove = response.data.Message[0].Count.UnApprove;
            this.expire = response.data.Message[0].Count.Expire;

          } else {
            Toast.fire({
              icon: "error",
              title: response.data.Message.Status,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            // Toast.fire({
            //   icon: "error",
            //   title: error.message || error,
            // });
          }
        });
    },
    PlusString() {
      if (this.ConsentId == "") {
        this.line7 = 'cmp-consent-id="' + this.GroupId + '"';
      } else {
        this.line7 = 'cmp-consent-id="' + this.ConsentId + '"';
      }
      this.str1 = "<";
      this.str2 = "script";
      this.str3 = ">";
      this.str4 = "/";
      this.line0 = this.str1 + this.str2;
      this.line1 = 'id="cmp_service"';
      // this.linenew = 'src="' + this.Hostname + '/consent/cookie.js"';
      this.linenew = 'src="' + process.env.VUE_APP_API_DOMAIN+ 'consent/cookie.js"';
      this.line2 = 'cmp-taxid="' + this._SelectTaxId + '"';
      this.line3 = 'cmp-secret-id="' + this.SecretIdCopy + '"';
      this.line4 = 'cmp-branchid="00000"';
      this.line5 = 'cmp-service-id="' + this.ServiceId + '"';
      this.line6 = 'cmp-policy-id="' + this.PolicyId + '"';
      // this.line7 = 'cmp-consent-id="' + this.ConsentId + '"';
      this.line8 = 'cmp-session-id=""';
      this.line9 = 'cmp-ipaddress=""';
      this.line10 = 'cmp-account-id=""';
      this.line11 = "async";
      this.line12 = "defer" + this.str3;
      this.PstringEnd = this.str1 + this.str4 + this.str2 + this.str3;
      this.WebScript =
        this.line0 +
        " " +
        this.line1 +
        " " +
        this.linenew +
        " " +
        this.line2 +
        " " +
        this.line3 +
        " " +
        this.line4 +
        " " +
        this.line5 +
        " " +
        this.line6 +
        " " +
        this.line7 +
        " " +
        this.line8 +
        " " +
        this.line9 +
        " " +
        this.line10 +
        " " +
        this.line11 +
        " " +
        this.line12 +
        this.PstringEnd;
      const object = [
        this.line2,
        this.line3,
        this.line4,
        this.line5,
        this.line6,
        this.line7,
        this.line8,
        this.line9,
        this.line10 + " " + this.line11 + " " + this.line12,
      ];

      for (const element of object) {
        this.Script = object;
      }
    },
  },
};
</script>
<style></style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.blurry-text {
  font-size: 14px;
  color: transparent;
  text-shadow: 0 0 8px #000;
}

.textcolor {
  color: #077893;
}
</style>
